import React from 'react'
import getConfig from 'next/config'

const { publicRuntimeConfig } = getConfig()

const SuggestedProductBanner = ({ suggestedProduct, onClick }) => {
  const imagePath = `${publicRuntimeConfig.suggestedProductImagesBasePath}${suggestedProduct.image}`

  return (
    <div
      onClick={() => onClick(suggestedProduct)}
      style={{
        cursor: 'pointer',
        borderRadius: 8,
        overflow: 'hidden',
        width: '100%',
        height: '100%',
        boxShadow: '0 1px 4px rgba(0,0,0,0.15)',
      }}
    >
      <img
        alt={suggestedProduct.product?.descripcion}
        src={imagePath}
        style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
        onError={(e) => {
          e.target.onerror = null
          e.target.src = '/static/images/no-image.jpg'
        }}
      />
    </div>
  )
}

export default SuggestedProductBanner
